import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const ExportIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16" fill="none"  >
    <path d="M16 3V14.1C16 14.9 15.3 15.6 14.5 15.6H1.5C0.7 15.6 0 14.9 0 14.1V3C0 2.2 0.7 1.5 1.5 1.5H3V3.3H1.8V13.7H14.2V3.3H13V1.5H14.5C15.3 1.5 16 2.2 16 3ZM4.4 3.6C4.1 3.9 4.1 4.4 4.4 4.7C4.7 5 5.2 5 5.5 4.7L7 3.2V10.1C7 10.6 7.5 11.1 8 11.1C8.5 11.1 9 10.7 9 10.1V3.2L10.5 4.7C10.8 5 11.3 5 11.6 4.7C11.8 4.5 11.8 4.3 11.8 4.1C11.8 3.9 11.7 3.7 11.6 3.5L8 0L4.4 3.6Z" fill="#2B3940" />
  </SvgIcon>
);
ExportIcon.displayName = "ExportIcon";
ExportIcon.muiName = "SvgIcon";

export default pure(ExportIcon);